module.exports = __webpack_public_path__ + "static/media/c-lunch.98cc65f1.jpg";